import ChildVpr from '@/models/ChildVpr'
import { callApi } from '@/_core/api/apiWrapper'
import ChildVprTaskProgress from '@/models/ChildVprTaskProgress'
import { VPR_TASK_RESULT_NONE } from '@/config'

export const fetchChildVprs = async (childId) => {
  const response = await callApi({
    method: 'get',
    url: `child-vpr/${childId}/`
  })
  if (response.data) response.data.results = response.data.results.map(el => new ChildVpr(el))
  return response
}

export const getChildVpr = async (childId, vprId) => {
  if (!childId || !vprId) return
  const response = await callApi({
    method: 'get',
    url: `child-vpr/${childId}/${vprId}/`
  })
  if (response.data) response.data = new ChildVpr(response.data)
  return response
}

export const getVprProgress = async (childId, vprId) => {
  if (!childId || !vprId) return
  const response = await callApi({
    method: 'get',
    url: `child-vpr/${childId}/${vprId}/startwork-progress/`
  })
  return response
}

export const saveVprProgress = async (childId, vprId, data) => {
  if (!childId || !vprId) return
  const response = await callApi({
    method: 'post',
    url: `child-vpr/${childId}/${vprId}/startwork-progress/`,
    data
  })
  return response
}

export const resetVprProgress = async (childId, vprId) => {
  if (!childId || !vprId) return
  const response = await callApi({
    method: 'get',
    url: `child-vpr/${childId}/${vprId}/startwork-progress-reset/`
  })
  return response
}

export const getTaskProgress = async (childId, vprId, taskId) => {
  if (!childId || !vprId || !taskId) return
  const response = await callApi({
    method: 'get',
    url: `child-vpr/${childId}/${vprId}/task-progress/${taskId}/`
  })
  if (response.data?.id) {
    response.data = new ChildVprTaskProgress(response.data)
  } else {
    response.data = new ChildVprTaskProgress({
      task_id: taskId,
      status: VPR_TASK_RESULT_NONE,
      player_state: null
    })
  }
  return response
}

export const saveTaskProgress = async (childId, vprId, taskId, data) => {
  if (!childId || !vprId || !taskId) return
  const response = await callApi({
    method: 'post',
    url: `child-vpr/${childId}/${vprId}/task-progress/${taskId}/`,
    data
  })
  if (response.data) response.data = new ChildVprTaskProgress(response.data.data)
  return response
}
